export default "<quill-editor [bounds]=\"'self'\" [modules]=\"modules\" [placeholder]=\"'Biography'\" [customToolbarPosition]=\"'bottom'\"></quill-editor>\n"